import React from "react";
import BottomSheet from "./BottomSheet";
import StickyFooter from "./StickyFooter";
import { TEXT_MUTED } from "./tokens";

export interface ConfirmSheetProps {
  open: boolean;
  title: string;
  /** Names the record that will be affected, e.g. "Delete “Coca-Cola 330ml”?". */
  message: React.ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  /** Red confirm button (default true: the sheet exists for destructive actions). */
  destructive?: boolean;
}

/**
 * Destructive confirmation as a bottom sheet: title, a message that names the
 * record, Cancel + red confirm. Cancel is always the safe default (backdrop
 * tap and Escape also cancel).
 */
const ConfirmSheet: React.FC<ConfirmSheetProps> = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  destructive = true,
}) => (
  <BottomSheet
    open={open}
    onClose={onCancel}
    title={title}
    footer={
      <StickyFooter
        position="static"
        destructive={destructive}
        primaryLabel={confirmLabel}
        onPrimary={onConfirm}
        cancelLabel={cancelLabel}
        onCancel={onCancel}
      />
    }
  >
    <div
      className="font-inter"
      style={{ padding: "0 20px 16px", fontSize: "15px", lineHeight: "22px", color: TEXT_MUTED }}
    >
      {message}
    </div>
  </BottomSheet>
);

export default ConfirmSheet;
